import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { FcSearch } from "react-icons/fc";
import "./PageNotFound.css"; // Import the custom CSS

const PageNotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="page-not-found-container">
      <div className="animation-container">
        <h1 className="error-title">
          4<FcSearch className="search-icon" />4
        </h1>
        <p className="error-message">
          Oops! The page you're looking for doesn't exist.
        </p>
        <button className="home-button" onClick={goHome}>
          <FaHome className="home-icon" /> Take Me Home
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
